import React from 'react';
import PropTypes from 'prop-types';

import { Widget } from '@typeform/embed-react';
import { Modal } from '@mantine/core';

import { breakpoints } from 'styles/theme.variables';

import { useMediaQuery } from '@mantine/hooks';

export default function FeatureRequests({ opened = false, close = () => {} }) {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);
  return (
    <Modal opened={opened} onClose={close} fullScreen={isMobile}>
      {import.meta.env.VITE_TYPEFORM_FEATURE_REQUESTS_ID !== 'false' && (
        <Widget
          className="feature-requests"
          style={{ minHeight: '60vh' }}
          id={import.meta.env.VITE_TYPEFORM_FEATURE_REQUESTS_ID}
        />
      )}
    </Modal>
  );
}

FeatureRequests.propTypes = {
  opened: PropTypes.bool,
  close: PropTypes.func,
};
